<div class="modal modal_full-height">
    <span class="modal__close" matDialogClose>
        <i class="material-icons">close</i>
    </span>
  <div class="modal-header">
    <div class="form-row">
      <div class="form-col form-col-8">
        <h3 class="modal-header__title">Будь ласка, введіть вашу дату народження для автентифікації</h3>
      </div>
    </div>
  </div>
  <form class="form-flex pt-1">
    <main class="modal-content popup-body">
      <div class="mr-bottom-16 d-flex flex-direction-column">
        <div class="flex-direction-row main-info">
          <mat-icon class="material-icons icon p-0">person</mat-icon>
          Доступ сплачувати за посилки та отримувати післяплату призупинено відповідно до
          вимог чинного законодавста про фінансовий моніторинг.
        </div>

        <div class="services-list__form"
             [formGroup]="birthDateGroup"
        >
          <div class="form-row">
            <div class="form-col form-col-3" (click)="picker.open()">
              <mat-form-field class="mat-block birth-date">
                <input class="birth-date-input"
                       [formControl]="birthDateControl"
                       [max]="maxDate"
                       matInput
                       readonly
                       [matDatepicker]="picker"
                       [value]="dateValue"
                       (dateInput)="onDateChange($event.value)"
                       [placeholder]="'Дата народження'">
                <mat-datepicker [touchUi]="isMobile$ | async"
                                startView="multi-year"
                                #picker>
                </mat-datepicker>
                <mat-error>{{ getError(birthDateControl, errors) }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div class="modal-footer">
      <div class="modal-footer-buttons pr-3">
        <div class="modal-footer-buttons__item">
          <button type="button"
                  class="mat-button_with-icon"
                  mat-button
                  (click)="moreInfo()">
            <mat-icon>info</mat-icon>
            Дізнатися більше
          </button>
          <button type="button"
                  color="primary"
                  mat-button
                  (click)="save()">
            Зберегти
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
